import React from "react";

export function ScoreContainer(props) {
  const { resultObj } = props;
  const result = resultObj?.result ? resultObj?.result : ''
  console.log(resultObj)
  const resCode = resultObj?.extra?.resCode ? resultObj?.extra?.resCode : ''
  const resRound = resultObj?.extra?.resRound ? resultObj?.extra?.resRound : ''
  return (
    <div className='score-result-container d-flex justify-content-end align-self-center'>
      <div className='fw-bold p-0 text-end '>
        {resCode} {resRound} {result}
      </div>
    </div>
  )
}